import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

// Assets
import OwnerImg from "../assets/homeAssets/owner.jpg";
import img1 from "../assets/homeAssets/ab2.jpeg";
import img2 from "../assets/logo3.jpg";
import img3 from "../assets/homeAssets/ab1.jpeg";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
  const container = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "About Us - ERA AESTHETICS";
  }, []);

  useGSAP(
    () => {
      // 1. Smooth Parallax for all images
      gsap.utils.toArray(".parallax-img").forEach((img) => {
        gsap.to(img, {
          y: -100,
          ease: "none",
          scrollTrigger: {
            trigger: img,
            scrub: true,
          },
        });
      });

      // 2. Text "Stagger Reveal"
      gsap.utils.toArray(".reveal-text").forEach((text) => {
        gsap.from(text, {
          y: 60,
          opacity: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
          },
        });
      });

      // 3. Floating Circle Background Element
      gsap.to(".floating-shape", {
        y: 200,
        rotate: 45,
        scrollTrigger: {
          trigger: ".founder-section",
          scrub: 2,
        },
      });
    },
    { scope: container },
  );

  return (
    <PageWrapper ref={container}>
      <FloatingShape className="floating-shape" />

      {/* --- SECTION 1: THE SPLIT HERO --- */}
      <HeroSection>
        <HeroGrid>
          <div className="title-area">
            <Label className="reveal-text">Über Uns</Label>
            <h1 className="reveal-text">
              Deine Adresse <br /> für moderne Ästhetik
            </h1>
          </div>
          <div className="image-area">
            <div className="main-img-wrap">
              <img src={img1} className="parallax-img" alt="Studio" />
            </div>
            <div className="sub-img-wrap">
              <img src={img2} className="parallax-img" alt="Details" />
            </div>
          </div>
        </HeroGrid>
      </HeroSection>

      {/* --- SECTION 2: THE MANIFESTO --- */}
      <ManifestoSection>
        <div className="inner">
          <Quote className="reveal-text">
            Meine Vision von moderner Schönheit
          </Quote>
          <div className="columns">
            <p className="reveal-text">
              Ich bin Elizabeta, Gründerin von Era Aesthetics & Academy in
              München. Aus meiner tiefen Leidenschaft für Hautpflege und
              Schönheit entstand der Wunsch, einen Ort zu schaffen, an dem
              Qualität, Expertise und persönliches Wohlbefinden im Mittelpunkt
              stehen. <br />
              <br /> Mein Schwerpunkt liegt auf professionellen, individuell
              abgestimmten Gesichtsbehandlungen. Aufgrund meiner großen Passion
              habe ich mein Angebot um die dauerhafte Haarentfernung erweitert,
              um ganzheitliche und moderne Beauty-Lösungen anbieten zu können.
            </p>
            <p className="reveal-text">
              Neben den Behandlungen biete ich bei Era Aesthetics & Academy in
              München auch zertifizierte Schulungen an, um mein Wissen und meine
              Erfahrung an angehende sowie professionelle Kosmetikerinnen
              weiterzugeben. <br />
              <br /> Mein Ziel ist es, dass meine Kundinnen und
              Schulungsteilnehmerinnen glücklich, zufrieden und mit einem guten
              Gefühl mein Studio verlassen. Era Aesthetics & Academy steht für
              stetige Weiterentwicklung und innovative Beauty-Konzepte.
            </p>
          </div>
        </div>
      </ManifestoSection>

      {/* --- SECTION 3: THE FOUNDER --- */}
      {/* <FounderSection className="founder-section">
        <FounderGrid>
          <div className="founder-img-box">
            <img src={OwnerImg} alt="Gründerin" />
            <FounderFloatingCard className="parallax-img">
              <h4>Elizabeta Bytyci</h4>
              <p>Master Aesthetician & Mentorin</p>
            </FounderFloatingCard>
          </div>
          <div className="founder-text-box">
            <span className="label reveal-text">Die Visionärin</span>
            <h2 className="reveal-text">
              Ein Jahrzehnt der <br /> <i>Eleganz.</i>
            </h2>
            <p className="reveal-text">
              Elizabetas Reise begann in den medizinischen Fachbereichen der
              Dermatologie und entwickelte sich zu einer Welt luxuriöser
              Ästhetik. Ihre Hände haben bereits tausende Menschen behandelt,
              doch ihr Ansatz bleibt heute so persönlich und einfühlsam wie bei
              ihrem ersten Patienten.
            </p>
            <Signature className="reveal-text">Elizabeta Bytyci</Signature>
          </div>
        </FounderGrid>
      </FounderSection> */}

      {/* --- SECTION 4: THE VALUES --- */}
      <ValuesSection>
        <div className="section-header">
          <h2 className="reveal-text">Unsere Philosophie</h2>
        </div>
        <ValueGrid>
          <ValueTile className="reveal-text">
            <span>01</span>
            <hr />
            <h3>Integrität</h3>
            <p>
              Wir handeln ehrlich, verantwortungsvoll und im Einklang mit
              unseren Werten.
            </p>
          </ValueTile>
          <ValueTile className="reveal-text">
            <span>02</span>
            <hr />
            <h3>Individualität</h3>
            <p>
              Wir stärken Persönlichkeit und eigenen Ausdruck statt Anpassung.
            </p>
          </ValueTile>
          <ValueTile className="reveal-text">
            <span>03</span>
            <hr />
            <h3>Exzellenz</h3>
            <p>
              Wir arbeiten mit höchstem Anspruch an Qualität, Disziplin und
              Weiterentwicklung.
            </p>
          </ValueTile>
        </ValueGrid>
      </ValuesSection>

      {/* --- SECTION 5: THE ACADEMY CONNECT --- */}
      <AcademyBanner>
        <div className="banner-bg">
          <img src={img3} className="parallax-img" alt="Akademie" />
        </div>
        <div className="banner-content">
          <h2 className="reveal-text">
            Exzellenz <br /> beginnt hier.
          </h2>
          <p className="reveal-text">
            Erlernen Sie die Methoden, die unser Studio zum Erfolg geführt
            haben.
          </p>
          <Link to={"/academy"}>
            <EnrollBtn className="reveal-text">Academy entdecken</EnrollBtn>
          </Link>
        </div>
      </AcademyBanner>
    </PageWrapper>
  );
};

export default AboutUs;

// --- Styled Components ---

const MAIN_COLOR = "#5a5248";
const ACCENT_BG = "#f4f2ef";

const PageWrapper = styled.div`
  background: #fdfcfb;
  color: ${MAIN_COLOR};
  overflow: hidden;
  position: relative;
`;

const FloatingShape = styled.div`
  position: absolute;
  top: 20%;
  right: -5%;
  width: 500px;
  height: 500px;
  border: 1px solid rgba(90, 82, 72, 0.1);
  border-radius: 50%;
  z-index: 0;
  pointer-events: none;
`;

const HeroSection = styled.section`
  min-height: 100vh;
  padding: 15vh 10% 10vh 10%;
`;

const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 50px;
  align-items: center;

  .title-area h1 {
    font-family: "Playfair Display", serif;
    font-size: clamp(3.5rem, 8vw, 6.5rem);
    line-height: 0.9;
    font-weight: 400;
    margin-top: 2rem;
    i {
      font-style: italic;
    }
  }

  .image-area {
    position: relative;
    height: 70vh;

    .main-img-wrap {
      width: 80%;
      height: 100%;
      overflow: hidden;
      border-radius: 200px 200px 0 0;
      img {
        width: 100%;
        height: 110%;
        object-fit: cover;
      }
    }

    .sub-img-wrap {
      position: absolute;
      bottom: -10%;
      right: 0;
      width: 45%;
      height: 50%;
      overflow: hidden;
      border: 15px solid #fdfcfb;
      img {
        width: 100%;
        height: 110%;
        object-fit: cover;
      }
    }
  }

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 20px;
    .image-area {
      height: 50vh;
      margin-top: 50px;
    }
  }
`;

const Label = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.5rem;
  font-size: 0.75rem;
  opacity: 0.5;
`;

const ManifestoSection = styled.section`
  padding: 20vh 10%;
  background: ${ACCENT_BG};

  .inner {
    max-width: 1100px;
    margin: 0 auto;
  }

  .columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 100px;
    margin-top: 4rem;
    p {
      font-size: 1.1rem;
      line-height: 1.8;
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    .columns {
      grid-template-columns: 1fr;
      gap: 40px;
    }
  }
`;

const Quote = styled.h2`
  font-family: "Playfair Display", serif;
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: 400;
  text-align: center;
  line-height: 1.4;
`;

const FounderSection = styled.section`
  padding: 20vh 10%;
`;

const FounderGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10%;
  align-items: center;

  .founder-img-box {
    position: relative;
    img {
      width: 100%;
      border-radius: 20px;
    }
  }

  .founder-text-box {
    h2 {
      font-family: "Playfair Display", serif;
      font-size: clamp(3rem, 5vw, 4.5rem);
      font-weight: 200;
      margin: 2rem 0;
    }
    p {
      font-size: 1.2rem;
      line-height: 1.8;
      opacity: 0.7;
    }
  }
`;

const FounderFloatingCard = styled.div`
  position: absolute;
  bottom: 10%;
  left: -10%;
  background: white;
  padding: 30px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
  border-radius: 10px;

  h4 {
    font-family: "Playfair Display", serif;
    font-size: 1.5rem;
    margin-bottom: 5px;
  }
  p {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    opacity: 0.5;
  }
`;

const Signature = styled.div`
  font-family:
    "Playfair Display", cursive; /* Assuming a Google Font is loaded */
  font-style: italic;
  font-size: 4rem;
  margin-top: 3rem;
  opacity: 0.6;
`;

const ValuesSection = styled.section`
  padding: 10vh 10% 20vh 10%;
  .section-header h2 {
    font-family: "Playfair Display", serif;
    font-size: 3rem;
    margin-bottom: 5rem;
  }
`;

const ValueGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ValueTile = styled.div`
  padding: 50px;
  border: 1px solid rgba(90, 82, 72, 0.1);
  transition: background 0.4s;

  span {
    font-size: 0.8rem;
    opacity: 0.5;
  }
  hr {
    border: none;
    border-top: 1px solid rgba(90, 82, 72, 0.1);
    margin: 2rem 0;
  }
  h3 {
    font-family: "Playfair Display", serif;
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  p {
    line-height: 1.6;
    opacity: 0.6;
  }

  &:hover {
    background: ${ACCENT_BG};
  }
`;

const AcademyBanner = styled.section`
  position: relative;
  height: 80vh;
  margin: 0 5% 5% 5%;
  border-radius: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .banner-bg {
    position: absolute;
    inset: 0;
    z-index: 1;
    img {
      width: 100%;
      height: 120%;
      object-fit: cover;
    }
    &:after {
      content: "";
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.4);
    }
  }

  .banner-content {
    position: relative;
    z-index: 2;
    color: white;
    h2 {
      font-family: "Playfair Display", serif;
      font-size: 4rem;
      margin-bottom: 2rem;
    }
    p {
      font-size: 1.2rem;
      opacity: 0.8;
      margin-bottom: 3rem;
    }
  }
`;

const EnrollBtn = styled.button`
  background: white;
  color: ${MAIN_COLOR};
  border: none;
  padding: 20px 40px;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
`;
